export const abilities = [
    {
        id: 'speed',
        name: '⚡ Speed Boost',
        description: 'Increase movement speed by 20%',
        apply: (player) => player.speed *= 1.2
    },
    {
        id: 'power',
        name: '💥 Power Up',
        description: 'Increase damage by 30%',
        apply: (player) => player.damage *= 1.3
    },
    {
        id: 'firerate',
        name: '🔥 Fire Rate',
        description: 'Shoot 20% faster',
        apply: (player) => player.autoShootMaxCooldown = Math.max(5, player.autoShootMaxCooldown * 0.8)
    },
    {
        id: 'magnet',
        name: '🧲 Coin Magnet',
        description: 'Attract coins from further away',
        apply: (player) => player.magnetRange += 100
    },
    {
        id: 'maxhp',
        name: '❤️ Max HP Up',
        description: 'Gain 20 max HP and heal to full',
        apply: (player) => {
            player.maxHp += 20;
            player.hp = player.maxHp;
        }
    },
    {
        id: 'laser',
        name: '🔴 Laser Weapon',
        description: 'Auto-fires laser beams at enemies',
        apply: (player) => {
            const existing = player.weapons.find(w => w.type === 'laser');
            if (existing) {
                existing.damage *= 1.3;
                existing.maxCooldown = Math.max(10, existing.maxCooldown * 0.9);
            } else {
                player.weapons.push({
                    type: 'laser',
                    cooldown: 0,
                    maxCooldown: 30,
                    damage: 15
                });
            }
        }
    },
    {
        id: 'orbit',
        name: '🛡️ Orbital Shields',
        description: 'Shields that orbit and damage enemies',
        apply: (player) => {
            const existing = player.weapons.find(w => w.type === 'orbit');
            if (existing) {
                existing.count += 2;
                existing.damage *= 1.2;
            } else {
                player.weapons.push({
                    type: 'orbit',
                    count: 3,
                    angle: 0,
                    radius: 50,
                    damage: 5
                });
            }
        }
    },
    {
        id: 'shotgun',
        name: '🔫 Shotgun',
        description: 'Fires multiple projectiles in a spread',
        apply: (player) => {
            const existing = player.weapons.find(w => w.type === 'shotgun');
            if (existing) {
                existing.damage *= 1.3;
                existing.maxCooldown = Math.max(15, existing.maxCooldown * 0.9);
            } else {
                player.weapons.push({
                    type: 'shotgun',
                    cooldown: 0,
                    maxCooldown: 45,
                    damage: 8
                });
            }
        }
    },
    {
        id: 'chain',
        name: '⚡ Chain Lightning',
        description: 'Lightning that chains between enemies',
        apply: (player) => {
            const existing = player.weapons.find(w => w.type === 'chain');
            if (existing) {
                existing.damage *= 1.3;
                existing.maxCooldown = Math.max(20, existing.maxCooldown * 0.9);
            } else {
                player.weapons.push({
                    type: 'chain',
                    cooldown: 0,
                    maxCooldown: 60,
                    damage: 20
                });
            }
        }
    },
    {
        id: 'boomerang',
        name: '🪃 Boomerang',
        description: 'Throws boomerangs that return and hit multiple times',
        apply: (player) => {
            const existing = player.weapons.find(w => w.type === 'boomerang');
            if (existing) {
                existing.count += 1;
                existing.damage *= 1.2;
                existing.maxCooldown = Math.max(30, existing.maxCooldown * 0.9);
            } else {
                player.weapons.push({
                    type: 'boomerang',
                    count: 2,
                    cooldown: 0,
                    maxCooldown: 90,
                    damage: 12,
                    range: 200
                });
            }
        }
    }
];

export function getRandomAbilities(count = 3) {
    const shuffled = [...abilities].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, count);
}
